import AnchorAPIError from '../../AnchorAPIError';

export function fetchAdCampaigns(webStationId: string) {
  return new Promise((resolve, reject) => {
    fetch(`/api/proxy/v3/sponsor/webStationId:${webStationId}/campaigns`, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then(resolve)
      .catch(reject);
  }).then(response => {
    // @ts-ignore
    const { status } = response;
    if (status === 200 || status === 400) {
      // @ts-ignore
      return response.json();
    }
    return Promise.reject(new AnchorAPIError(response, 'Server error.')).then(
      responseJson => responseJson
    );
  });
}
